import { instance } from "libs/api";

import { ApiRoutesAiConversations } from "../../constants/enums";
import { WhatsAppConversationsListResponse } from "../../aiConversations.types";
import { GetConversationsParams } from "./getConversations.types";

export const requestGetConversations = async (
  params: GetConversationsParams
): Promise<WhatsAppConversationsListResponse> => {
  return await instance.get(ApiRoutesAiConversations.Conversations, { params });
};
